import classNames from 'classnames'
import { type JSX } from 'react'
import { useTranslation } from 'react-i18next'

import { Body1, Body2 } from '@ui/Typography'

import { Box } from '@shared/components/Box'
import { CopyButton } from '@shared/components/CopyButton'

import { CopyDataList } from './ReferralLink'

import styles from './ReferralLink.module.scss'

interface Props {
  item: CopyDataList
  value: string
  isLinkHub?: boolean
}

export const ReferralCodeField = (props: Props): JSX.Element => {
  const { item, value, isLinkHub } = props
  const { t } = useTranslation()

  return (
    <li className={classNames(styles.iBReferralLinkItem, { [styles.noMarginTop]: isLinkHub })}>
      <Body2>{item.name}</Body2>
      <Box flex align='center' gap='x8' mt='x8' className={styles.ibReferralLinkCopyFieldWrapper}>
        <Box
          className={classNames(styles.ibReferralLinkCopyField, {
            [styles.ibReferralLinkCopyFieldModified]: isLinkHub,
          })}
          flex
          align='center'
          justify='space-between'
          gap='x8'
        >
          <Body1 className={styles.iBReferralLinkCopyValue}>{value}</Body1>
        </Box>

        <CopyButton
          value={value}
          onCopy={item.onCopyGAEventClick}
          disabled={!value}
          successMessage={`${t('Copied')}!`}
          aria-label='Copy referral code'
        />
      </Box>
    </li>
  )
}
